<div class="table-wrap">
    @if(companiesResource.isLoading())
    {
    <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-60">
        <div class="continuous-loader" role="status"></div>
        <h4>Indlæser regnskaber</h4>
    </div>
    }
    @else
    {
    <table class="table table-hover table-striped">
        @if(!companiesResource.hasValue() || companiesResource.value().length === 0)
        {
        <thead>
            <tr>
                <th class="no-data">Ingen regnskaber at vise.</th>
            </tr>
        </thead>
        }
        @else
        {
        <thead class="thead-sticky">
            <tr>
                <th style="width: 80px;" scope="col"> Id </th>
                <th scope="col"> Navn </th>
                <th style="width: 180px;" scope="col"> </th>
            </tr>
        </thead>
        }

        <tbody>
            @for (item of filterCompanies(); track item.companyId)
            {
            <tr #row scope="row">
                <td style="max-width: 40px; width: 40px;">
                    <div class="mt-2">{{ item.companyId }}</div>
                </td>
                <td (dblclick)="setCompanyNameEditable(item, row);">
                    @if (item.isEditing) {
                    <input type="text" class="form-control mb-1" [value]="item.tempName" placeholder="Navn"
                        [disabled]="item.isSaving" (keyup)="onEditCompanyName($event, item)">
                    <input type="text" class="form-control" [value]="item.tempNameUrl" placeholder="Navn (Url)"
                        [disabled]="item.isSaving" (keyup)="onEditCompanyUrl($event, item)">
                    <sub style="display: block; font-size: smaller; margin-top: 3px;">
                        (Url) {{ encodeUrl(item.tempNameUrl) }}
                    </sub>
                    }
                    @else {
                    <div class="mt-2 text-truncate" style="height: 44px;">
                        <span style="user-select: none;">{{ item.name }}</span>
                        <sub style="user-select: none; display: block; font-size: smaller; margin-top: 3px;">
                            <i title="Kopier til udklipsholder" (click)="copyToClipboard(item.nameUrl)"
                                class="fa-regular fa-copy"></i>
                            (Url)
                            <span style="user-select: text; display: inline-block; width: 100%;">{{ item.nameUrl
                                }}</span>
                        </sub>
                    </div>
                    }
                </td>

                <td class="text-nowrap">
                    <div class="mt-2 text-end">
                        @if (isEditing()) {
                        <button ngbTooltip="Accepter" class="btn btn-success me-1" title="Gem ændringer"
                            [disabled]="item.isSaving || !item.isEditing" (click)="onSaveCompanyItem(item);">
                            @if (item.isSaving) {
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Gemmer...</span>
                            </div>
                            } @else {
                            <i class="fa-solid fa-check"></i>

                            }
                        </button>
                        <button ngbTooltip="Fortryd" class="btn btn-danger" (click)="onResetCompanyItem(item)"
                            title="Fortryd ændringer" [disabled]="item.isSaving || !item.isEditing">
                            <i class="fa-solid fa-xmark-large"></i>
                        </button>
                        } @else {
                        <button ngbTooltip="Rediger navn" class="btn btn-primary me-1"
                            [disabled]="item.isSaving || item.isEditing" (click)="setCompanyNameEditable(item, row);">
                            <i class="fa-regular fa-pencil"></i>
                        </button>

                        <div class="btn-group">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                Funktioner
                            </button>
                            <ul class="dropdown-menu">
                                @if(environment !== "Production")
                                {
                                <li>
                                    <button class="dropdown-item text-end" (click)="createSync(item.companyId)">
                                        Opret synkronisering <i class="fas fa-plus fa-xs"></i><i
                                            class="fas fa-rotate"></i>
                                    </button>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                }
                                <li>
                                    <button class="dropdown-item text-end text-danger"
                                        (click)="onDeleteCompanyItem(item)" title="Slet regnskab"
                                        [disabled]="item.isSaving || item.isEditing">
                                        Slet <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        }
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>
    }
</div>